(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["nutech-product-card-content"] && !Shopify.designMode) return;
  try {
    (async () => {
  const { CartLinesUpdateEvent } = await import('@shopify/events');
  class NutechPurchase extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.addEventListener('change', () => {
        const option = this.querySelector('select')?.selectedOptions[0];
        if (option?.dataset.price) this.closest('.np-card').querySelector('[data-card-price]').textContent = option.dataset.price;
        this.querySelector('[data-purchase-status]').textContent = '';
      });
      this.addEventListener('submit', async (event) => {
        event.preventDefault();
        if (this.busy) return;
        const form = event.target;
        if (!(form instanceof HTMLFormElement) || !form.reportValidity()) return;
        const button = event.submitter;
        const buyNow = button?.hasAttribute('data-buy-now');
        const buttons = [...form.querySelectorAll('button[type=submit]')];
        const status = this.querySelector('[data-purchase-status]');
        const originalLabels = buttons.map(item => item.textContent);
        const data = new FormData(form);
        const sections = [...new Set([...document.querySelectorAll('cart-items-component[data-section-id]')].map(item => item.dataset.sectionId))];
        if (sections.length) data.set('sections', sections.join(','));
        data.set('sections_url', window.location.pathname);
        data.delete('return_to');
        this.busy = true;
        this.setAttribute('aria-busy', 'true');
        status.removeAttribute('data-error');
        status.textContent = this.dataset.busy;
        buttons.forEach(item => item.disabled = true);
        if (button) button.textContent = this.dataset.busy;
        const deferred = buyNow ? null : CartLinesUpdateEvent.createPromise();
        deferred?.promise.catch(() => {});
        if (deferred) this.dispatchEvent(new CartLinesUpdateEvent({ action: 'add', context: 'product', lines: [{ merchandiseId: String(data.get('id')), quantity: 1 }], promise: deferred.promise }));
        let added = false;
        let navigating = false;
        try {
          const endpoint = new URL(form.action);
          endpoint.pathname = endpoint.pathname.replace(/\/$/, '') + '.js';
          const response = await fetch(endpoint, { method: 'POST', body: data, headers: { Accept: 'application/json' } });
          const result = await response.json();
          if (!response.ok || result.status) throw new Error(this.dataset.error);
          added = true;
          if (buyNow) {
            navigating = true;
            window.location.assign(this.dataset.checkoutUrl);
            return;
          }
          const cartResponse = await fetch(this.dataset.cartUrl + '.js', { headers: { Accept: 'application/json' } });
          if (!cartResponse.ok) throw new Error(this.dataset.error);
          const cart = await cartResponse.json();
          deferred.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: { items: cart.items, source: 'product-form-component', sourceId: form.id, itemCount: 1, productId: this.dataset.productId, sections: result.sections, didError: false } });
          status.textContent = this.dataset.added;
          this.querySelector('[data-purchase-cart]').hidden = false;
        } catch (error) {
          deferred?.reject(error);
          if (added) {
            navigating = true;
            window.location.assign(this.dataset.cartUrl);
            return;
          }
          status.setAttribute('data-error', '');
          status.textContent = this.dataset.error;
        } finally {
          if (navigating) return;
          this.busy = false;
          this.removeAttribute('aria-busy');
          buttons.forEach((item, index) => { item.disabled = false; item.textContent = originalLabels[index]; });
        }
      });
    }
  }
  if (!customElements.get('nutech-purchase')) customElements.define('nutech-purchase', NutechPurchase);
  })().catch(() => {});
  } catch(e) { console.error(e); }
})();

})();
